<section class="py-20 bg-gradient-to-r from-blue-700 via-indigo-700 to-slate-900 text-white relative overflow-hidden">
  <!-- Subtle Grid Pattern Background -->
  <div class="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]"></div>

  <div class="container mx-auto px-6 relative z-10 text-center max-w-4xl space-y-8">
    <div class="w-16 h-16 rounded-3xl bg-white/10 backdrop-blur-md mx-auto flex items-center justify-center text-3xl text-blue-300 border border-white/20">
      <i class="fa-solid fa-graduation-cap"></i>
    </div>

    <h2 class="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
      Ready to Inspire Students & Build Your Teaching Brand?
    </h2>

    <p class="text-lg text-blue-100 max-w-2xl mx-auto leading-relaxed">
      Join hundreds of Sri Lankan tutors offering live classes, video courses, and study materials on Learnbird today.
    </p>

    <div class="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
      <a
        routerLink="/auth/register"
        [queryParams]="{ role: 'instructor' }"
        class="daisy-btn daisy-btn-lg bg-white text-blue-900 hover:bg-slate-100 border-none font-bold px-8 shadow-xl flex items-center gap-2"
      >
        <i class="fa-solid fa-user-plus"></i>
        <span>Create Instructor Account</span>
      </a>

      <a
        routerLink="/contact"
        class="daisy-btn daisy-btn-outline daisy-btn-lg text-white border-white/40 hover:bg-white/10 hover:border-white flex items-center gap-2"
      >
        <i class="fa-solid fa-headset"></i>
        <span>Talk to Our Team</span>
      </a>
    </div>
  </div>
</section>
